<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div>
          <img class="logo-footer" :src="img.LogoFooter" alt="" />
          <p style="max-width: 350px; margin-top:150px" class="p-footer">
            Instantly are in most her. At many, a been some don't he they the
            his to is fail with I that for titles let butter check and a picture
            because
          </p>
        </div>
        <div class="desktop">
          <h5 class="h5-title-footer mb-20">Navigation</h5>
          <div class="mt-20">
            <p class="p-footer">Home</p>
            <p class="p-footer">Pages</p>
            <p class="p-footer">About us</p>
          </div>
        </div>
        <div class="desktop">
          <h5 class="h5-title-footer mb-20">Quick links</h5>
          <div class="mt-20">
            <p class="p-footer">Contact Us</p>
            <p class="p-footer">Terms Of Service</p>
            <p class="p-footer">Privacy Policy</p>
          </div>
        </div>
        <div class="desktop">
          <h5 class="h5-title-footer mb-20">Popular Courses</h5>
          <div class="mt-20">
            <p class="p-footer">Web Design</p>
            <p class="p-footer">Web Development</p>
            <p class="p-footer">Mobile Development</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="flex align-center justify-space-between desktop">
        <div class="copyright">
          &copy; {{ year }}, All rights reserved by themeix.
        </div>
        <div style="float: right; font-size:15px" class="flex">
          <span class="c-white">Follow :</span>
          <div
            style="display: flex; justify-content: center;z-index: 1000"
            class="ml-20"
          >
            <a href=" https://t.me/+9xD_UHwNiOM0NTg9">
              <img :src="icons.SocialZaloIcon" alt=""
            /></a>
            <a href="mailto:freestyle.myapp@gmail.com">
              <img class="mr-10 ml-10" :src="icons.PhoneIcon" alt="" />
            </a>
            <a href="https://www.facebook.com/people/Hocvivu/61561372160944/">
              <img :src="icons.FaceBookIcon" alt="" />
            </a>
          </div>
          <!-- <img class="ml-20" :src="img.SocialLink" alt="" /> -->
        </div>
      </div>
      <div class="mobile">
        <div style="font-size:15px">
          <span class="c-white">Follow :</span>
          <div
            class="mt-20"
            style="position:absolute; z-index: 10000; left: 50%;    transform: translate(-50%, -50%);"
          >
            <a href="https://t.me/+9xD_UHwNiOM0NTg9">
              <img :src="icons.SocialZaloIcon" alt=""
            /></a>
            <a href="mailto:freestyle.myapp@gmail.com">
              <img class="mr-10 ml-10" :src="icons.PhoneIcon" alt="" />
            </a>
            <a href="https://www.facebook.com/people/Hocvivu/61561372160944/">
              <img :src="icons.FaceBookIcon" alt="" />
            </a>
          </div>
          <!-- <img class="ml-20" :src="img.SocialLink" alt="" /> -->
        </div>
        <div class="copyright" style="margin-top:25px">
          &copy; {{ year }}, All rights reserved by themeix.
        </div>
      </div>
    </div>
    <div class="effects-footer">
      <img :src="icons.EffectsFooter" alt="" />
    </div>
  </footer>
</template>
<script>
import LogoFooter from "@/assets/img/logo/logohocvivu.png";
import SocialLink from "@/assets/img/logo/SocialLink.png";
import EffectsFooter from "@/assets/img/svg_edu/EffectsFooter.svg";
import SocialZaloIcon from "@/assets/img/svg/telegram-svgrepo-com.svg";
import PhoneIcon from "@/assets/img/svg/email-8-svgrepo-com.svg";
import FaceBookIcon from "@/assets/img/svg/facebook-svgrepo-com.svg";
export default {
  name: "MainFooter",
  props: {},
  data() {
    return {
      year: new Date().getFullYear(),
      img: {
        LogoFooter,
        SocialLink
      },
      icons: {
        EffectsFooter,
        SocialZaloIcon,
        PhoneIcon,
        FaceBookIcon
      }
    };
  },
  methods: {}
};
</script>

<style scoped>
.logo-footer {
  position: absolute;
  max-width: 300px;
  top: -70px;
  left: -10px;
}
.footer-content {
  position: relative;
  margin-top: 80px;
  padding-bottom: 30px;
  width: 100%;
  border-bottom: 1px solid #ffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.effects-footer {
  position: absolute;
  right: -10px;
  top: -40px;
  z-index: 100;
}
.copyright {
  font-size: 15px;
  color: #fff;
}
footer {
  position: relative;
  min-height: 350px;
  width: 100%;
  background-image: url("~@/assets/img/img_edu/Footer.png");
  background-size: cover;
  background-position: left;
  background-repeat: no-repeat;
  overflow: hidden;
}
.h5-title-footer {
  margin-bottom: 40px;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  text-align: left;
  color: #fff;
}
.p-footer {
  font-size: 15px;
  font-weight: 400;
  line-height: 25.6px;
  text-align: left;
  color: #fff;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  footer {
    margin-top: 50px;
    background: #3d89ec;
  }
  .effects-footer {
    position: absolute;
    right: -40px;
    top: -100px;
    z-index: 100;
  }
  .footer-content {
    display: block;
    margin-top: 0px;
    padding-bottom: 30px;
    border-bottom: 1px solid #ffff;
  }
}
</style>
